// Conventional default ports per service type for `cloudgrid dev`.
//
// First-run `cloudgrid dev` (no lock file) is a jarring UX when it lands on
// a random ephemeral port — most users expect tooling-standard defaults:
// 3000 for Node/Next.js, 5000 for Python, 8080 for static. This module
// returns the convention default for a given service type; the allocator
// linear-scans +1..+20 from there, then falls through to ephemeral if
// the whole window is taken.
//
// Returns `null` for unknown / cron types so the caller falls back to the
// existing ephemeral path without ceremony.

/**
 * Return the conventional default port for a given service type, or
 * `null` if the type has no convention (caller falls back to ephemeral).
 *
 * - `node`, `nextjs` → 3000
 * - `python`         → 5000
 * - `static`         → 8080
 * - anything else    → null
 */
export function defaultPortForServiceType(type: string): number | null {
  switch (type) {
    case 'node':
    case 'nextjs':
      return 3000;
    case 'python':
      return 5000;
    case 'static':
      return 8080;
    default:
      return null;
  }
}
